<script>
import CheckinCheckoutPhotoReportService from '@src/services/CheckinCheckoutPhotoReportService'
import ApiModeVuetable from '@src/components/ApiModeVuetable'
import Layout from '@layouts/main.vue'
import Breadcrumb from '@/src/components/Breadcrumb.vue'
import PageHeader from '@/src/components/PageHeader.vue'
import Pagination from '@src/mixins/pagination.vue'
import swalFeedback from '@src/mixins/swalFeedback'
import vuetableFormatters from '@src/mixins/vuetableFormatters'
import filterVuetable from '@src/mixins/filterVuetable'
import FilterLabelButton from '@/src/components/FilterLabelButton.vue'
import AddLabelButton from '@/src/components/AddLabelButton.vue'
import checkinCheckoutPhotoReportFilterModal from '@/src/router/views/checkinCheckoutPhotoReport/checkinCheckoutPhotoReportFilterModal';
import checkinCheckoutPhotoReportModal from '@/src/router/views/checkinCheckoutPhotoReport/checkinCheckoutPhotoReportModal';
import checkinCheckoutPhotoReportFields from '@src/fields/checkinCheckoutPhotoReportFields';
import * as storeFile from "@state/store";
import { authComputed } from '@state/helpers'

const i18nCommon = 'COMMON'
const i18nKey = 'CHECKIN_CHECKOUT_PHOTO_REPORTS'

export default {
    metaInfo() {
        return {
            title: this.i18nCheckinCheckoutPhotoReport,
        }
    },
    components: {
        ApiModeVuetable,
        Layout,
        Breadcrumb,
        PageHeader,
        FilterLabelButton,
        AddLabelButton,
        checkinCheckoutPhotoReportFilterModal,
        checkinCheckoutPhotoReportModal,
    },
    mixins: [
        Pagination,
        swalFeedback,
        vuetableFormatters,
        filterVuetable,
        checkinCheckoutPhotoReportFields
    ],
    data() {
        return {
            i18nCommon,
            i18nKey,
            modalIsEdit: false,
            additionalParameters: {
                with: ['file'],
            },
            perPage: 10,
            submitLoading: false,
            css: {},
            sortOrder: [
                {
                    field: 'created_at',
                    direction: 'desc',
                },
            ],
            filters: {
                createdAt: null,
                type: null,
                users: [],
            },
        }
    },
    computed: {
        ...authComputed,
        storeFile() {
            return storeFile
        },
        items() {
            return [
                {
                    text: 'Home',
                    href: '/',
                },
                {
                    text: this.getI18nModified({
                        prefix: i18nCommon,
                        suffix: 'report',
                        modifier: 2,
                    }),
                    active: true,
                },
                {
                    text: this.getI18nModified({
                        prefix: i18nKey,
                        suffix: 'TITLES.checkin_checkout_photo_report',
                        modifier: 2,
                    }),
                },
            ]
        },

        i18nCheckinCheckoutPhotoReport() {
            return this.getI18nModified({
                prefix: i18nKey,
                suffix: 'TITLES.checkin_checkout_photo_report',
                modifier: 2,
            })
        },
        i18nNewReport() {
            return this.getI18n(i18nKey, 'BUTTONS.new_report')
        },
        i18nExport() {
            return this.getI18n(i18nKey, 'TITLES.export')
        },
    },
    methods: {
        createAdditionalParameters() {
            return this.formatParameters({
                with: ['file'],
                type: this.filters.type ? String(this.filters.type.value) : null,
                user_id: this.filters.users.map((user) => user.id),
                created_at: this.formatFilterDate(this.filters.createdAt),
            })
        },

        fetch(url, params) {
            return CheckinCheckoutPhotoReportService.fetchVuetable(url, params)
        },

        showCreateModal() {
            this.$refs.checkinCheckoutPhotoReportModal.showModal()
        },

        filter(appliedFilters) {
            this.filters = appliedFilters;
            this.additionalParameters = this.createAdditionalParameters()
            this.refreshTable()
        },

        showFilterModal() {
            this.$nextTick(() => this.$refs.checkinCheckoutPhotoReportFilterModal.showModal(this.filters))
        },

        refreshTable() {
            this.$refs.vuetable.refresh()
        },
    },
}
</script>

<template>
    <Layout>
        <div class="col-12">
            <Breadcrumb :items="items" />
            <div class="row mt-3">
                <div class="col-sm-4 mb-3 form-inline"></div>
                <div class="col-sm-8 mb-3">
                    <div class="text-sm-right">
                        <filter-label-button @onClick="showFilterModal" />
                        <add-label-button :title="i18nNewReport" @onClick="showCreateModal" />
                    </div>
                </div>
            </div>
            <div class="card card-pdv">
                <PageHeader :title="i18nCheckinCheckoutPhotoReport" />
                <div class="card-body">
                    <api-mode-vuetable
                        ref="vuetable"
                        :fetch-data="fetch"
                        :fields="checkinCheckoutPhotoReportFields"
                        :per-page="perPage"
                        :additional-parameters="additionalParameters"
                        :sort-order="sortOrder">
                        <template slot="file" slot-scope="props">
                            <div v-if="props.rowData.file && props.rowData.file?.url">
                                <a :href="props.rowData.file.url">
                                    <i class="fe-download" />
                                </a>
                            </div>
                            <div v-if="props.rowData.type === 'link_checkin'">
                                <a :href="`https://book.pdvmundo.com.br/${storeFile.default.getters['auth/tenantId']}/${props.rowData.id}?token=${currentToken}`" target="_blank">
                                    <i class="fe-download" />
                                </a>
                            </div>
                        </template>
                    </api-mode-vuetable>
                </div>
            </div>
        </div>
        <checkin-checkout-photo-report-modal
            ref="checkinCheckoutPhotoReportModal"
            @refresh="refreshTable"
        />
        <checkin-checkout-photo-report-filter-modal
            ref="checkinCheckoutPhotoReportFilterModal"
            :handle-submit="filter"
        />
    </Layout>
</template>
